function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useRef } from 'react';
import { educationPeriodDateSpread } from '../../date';
import styles from '../../../sass/navigation.module.scss';
export default (function (_ref) {
  var selectedEducationPeriod = _ref.selectedEducationPeriod,
      _ref$availableEducati = _ref.availableEducationPeriods,
      availableEducationPeriods = _ref$availableEducati === void 0 ? {} : _ref$availableEducati,
      selectYearAction = _ref.selectYearAction,
      unsavedForm = _ref.unsavedForm,
      unsavedChangesModal = _ref.unsavedChangesModal,
      onRoleChange = _ref.onRoleChange,
      openModal = _ref.openModal,
      style = _ref.style;
  var linkRef = useRef(null);
  var available = [];

  if (Object.keys(availableEducationPeriods).length) {
    available = Object.keys(availableEducationPeriods).map(function (edpdCode) {
      return _objectSpread(_objectSpread({}, availableEducationPeriods[edpdCode]), {}, {
        date: educationPeriodDateSpread(availableEducationPeriods[edpdCode].academicYrStartDate, availableEducationPeriods[edpdCode].academicYrEndDate)
      });
    });
  }

  function switchAcademicYear(code) {
    selectYearAction(code);
    if (onRoleChange) onRoleChange();
  }

  function selectAcademicYear(code, e) {
    var localSwitchAcademicYear = switchAcademicYear.bind(this, code);
    e.preventDefault();
    if (!code) return;

    if (unsavedForm) {
      openModal(unsavedChangesModal, {
        form: unsavedForm,
        callback: localSwitchAcademicYear,
        saveButtonText: 'Save & Continue',
        onSuccessAction: localSwitchAcademicYear,
        modalCloseFocusElem: linkRef.current
      });
    } else switchAcademicYear(code);
  }

  function academicYearMenuItem(educationPeriod) {
    var code = educationPeriod.code,
        date = educationPeriod.date;
    if (code.toString() === selectedEducationPeriod.toString()) return null;
    return /*#__PURE__*/React.createElement("li", {
      key: code,
      className: "edperiod-item",
      role: "presentation"
    }, /*#__PURE__*/React.createElement("a", {
      role: "menuitem",
      href: "#",
      onClick: function onClick(e) {
        return selectAcademicYear(code, e);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Select this academic year: "), date));
  }

  function selectAcademicYearDropdown(style) {
    var displayDate = available.find(function (ep) {
      return ep.code.toString() === selectedEducationPeriod.toString();
    }).date;
    return /*#__PURE__*/React.createElement("div", {
      className: "dropdown cb-dropdown ".concat(styles['select-academic-year']),
      style: style
    }, /*#__PURE__*/React.createElement("a", {
      className: "dropdown-toggle",
      style: {
        color: '#0077c8'
      },
      "aria-haspopup": true,
      "aria-current": true,
      "data-toggle": "dropdown",
      href: "#",
      id: "dropdownMenuAcademicYearSelection",
      role: "button",
      ref: linkRef
    }, /*#__PURE__*/React.createElement("span", {
      className: "roboto-slab-bold"
    }, displayDate), /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Press Enter for Dropdown."), /*#__PURE__*/React.createElement("i", {
      className: "cb-glyph cb-down",
      style: {
        marginLeft: '6px'
      },
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("i", {
      className: "cb-glyph cb-up hidden",
      style: {
        marginLeft: '6px'
      },
      "aria-hidden": "true"
    })), /*#__PURE__*/React.createElement("ul", {
      className: "dropdown-menu",
      role: "menu",
      "aria-labelledby": "dropdownMenuAcademicYearSelection"
    }, available.map(function (edpd) {
      return academicYearMenuItem(edpd);
    })));
  }

  if (available.length > 1 && selectedEducationPeriod) return selectAcademicYearDropdown(style);

  if (available.length === 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['select-academic-year'],
      style: style
    }, available[0].date);
  }

  return null;
});